module.exports = __webpack_public_path__ + "img/wj_pic_tjcg.08685c7b.png";